module.exports = __webpack_public_path__ + "static/img/deliveroo_gestion.da62943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/deliveroo_gestion.png
// module id = HeOp
// module chunks = 4